import { AlternativesComparisonReadModel } from "@Alternatives/AlternativesLists/Domain/readmodels";

export class AlternativesComparisonDialogViewModel
{
    opened: boolean = false;
    initialized: boolean = false;

    data: AlternativesComparisonReadModel | null = null;

    show()
    {
        this.initialized = false;
        this.data = null;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.data = null;
        this.initialized = false;
    }

    setData(data: AlternativesComparisonReadModel)
    {
        this.data = data;
        this.initialized = true;
    }
}